export const SIGNUP = 'SIGNUP'
export const SIGNUP_ERR = 'SIGNUP_ERR'
export const SIGNIN = 'SIGNIN'
export const SIGNIN_ERR = 'SIGNIN_ERR'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_ERR = 'UPDATE_PROFILE_ERR'
export const SERVICE_ON = 'SERVICE_ON'
export const SERVICE_OFF = 'SERVICE_OFF'
export const SERVICE_SEND = 'SERVICE_SEND'
export const GET_PROFILE = 'GET_PROFILE'
export const GET_ALL_USER = 'GET_ALL_USER'
export const UPDATE_ALL_USER = 'UPDATE_ALL_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const GET_ALL_COMMANDE = 'GET_ALL_COMMANDE'
export const GET_ALL_CANDIDAT = 'GET_ALL_CANDIDAT'
export const GET_ALL_PARTENAIRE = 'GET_ALL_PARTENAIRE'
export const GET_ALL_ERR = 'GET_ALL_ERR'
export const GET_ACCEPT_CANDIDACY = 'GET_ACCEPT_CANDIDACY'
export const CANDIDACY_ERR = 'CANDIDACY_ERR'
export const CANDIDACY_REMOVE = 'CANDIDACY_REMOVE'

export const REMOVE_ERR = 'REMOVE_ERR'
export const CREATE_ERR = 'CREATE_ERR'
export const REMOVE_SERVICE = 'REMOVE_SERVICE'
